"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.SlideContent = exports.LiquidPixelViewerMobileContainer = exports.Caption = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var MAX_PX = '265px';
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "mobileCarouselStyles__Wrapper",
  componentId: "sc-166v005-0"
})(["display:flex;flex-direction:column;justify-content:space-between;"]);
exports.Wrapper = Wrapper;
var SlideContent = _styledComponents["default"].div.withConfig({
  displayName: "mobileCarouselStyles__SlideContent",
  componentId: "sc-166v005-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;border:1px solid #eee;box-sizing:border-box;margin:10px;overflow-y:hidden;img,.video-js{max-width:", ";max-height:", ";}.video-js{margin:0 auto;}"], MAX_PX, MAX_PX);
exports.SlideContent = SlideContent;
var Caption = _styledComponents["default"].div.withConfig({
  displayName: "mobileCarouselStyles__Caption",
  componentId: "sc-166v005-2"
})(["font-size:1.2rem;font-weight:bold;text-align:center;margin-bottom:10px;"]);
exports.Caption = Caption;
var LiquidPixelViewerMobileContainer = _styledComponents["default"].div.withConfig({
  displayName: "mobileCarouselStyles__LiquidPixelViewerMobileContainer",
  componentId: "sc-166v005-3"
})(["max-width:", ";max-height:", ";min-width:250px;min-height:250px;"], MAX_PX, MAX_PX);
exports.LiquidPixelViewerMobileContainer = LiquidPixelViewerMobileContainer;
//# sourceMappingURL=mobileCarouselStyles.js.map